import { WarningCircleIcon } from "@phosphor-icons/react/WarningCircle";
import type { QuoteRestriction } from "@freightsimple/generated-dashboard-openapi-client/models/QuoteRestriction";
import { BulletList } from "@freightsimple/ui-core/Typography/BulletList";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface RestrictionsWarningBubbleProps {
  restrictions: QuoteRestriction[];
}

function QuotesRestrictionsWarningBubble(
  props: RestrictionsWarningBubbleProps,
) {
  const { restrictions } = props;

  return (
    // `roomy` is what supplies the padding and the comfortable 14px base the
    // hand-rolled content div used to add on top of the tooltip's own.
    <Tooltip
      side="bottom"
      roomy
      content={
        <Stack gap={2}>
          <T weight="bold">Restrictions for this service</T>
          <BulletList>
            {restrictions.map((r) => (
              <li key={r.description}>
                <T size="xs" color="secondary">
                  {r.description}
                </T>
              </li>
            ))}
          </BulletList>
        </Stack>
      }
    >
      <Icon
        icon={WarningCircleIcon}
        size="lg"
        weight="fill"
        color="text-gold"
      />
    </Tooltip>
  );
}

export default QuotesRestrictionsWarningBubble;
